import {
  BANK_FETCHING,
  BANK_FAILED,
  BANK_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case BANK_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case BANK_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case BANK_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}